import React from "react";
import { Col, Row, Tooltip } from "antd";

const OnlinePaymentStatistics = (
  <div className="dashboardTooltip">
    <p>
      "Payments Collected Online": This value is the percentage of all money
      received from tenants paying online (including Electronic Cash Payments)
      over the last 60 days, which includes rent, deposits, pre-payments, rental
      applications, and other tenant charges.{" "}
    </p>
    <br />
    <p>
      {" "}
      "Units Paid Online": This value represents the percentage of units that
      have made a payment online (including Electronic Cash Payments) in the
      last 60 days.
    </p>
  </div>
);

const ActivatedToolTip = (
    <div className="dashboardTooltip">
      <h4>
      Activated Units and Homes
      </h4>
      <br />
      <p>
      This group has successfully activated at least one online portal and are able to make payments online.
      </p>
    </div>
  );

  const NonActivatedToolTip = (
    <div className="dashboardTooltip">
      <h4>
      Non-Activated Units and Homes
      </h4>
      <br />
      <p>
      This group is eligible to pay online, but need to have at least one online portal activated first.
      </p>
    </div>
  );
  const NoEmailToolTip = (
    <div className="dashboardTooltip">
      <h4>
      Units and Homes Without Email Addresses
      </h4>
      <br />
      <p>
      This group has no associated emails and therefore cannot activate an online portal.
      </p>
    </div>
  );
const OnlinePayments = () => {
  return (
    <div className="OnlinePayments">
      <div className="dshbrd_acrdn">
        <div
          id="collapsePayments"
          className="collapse"
          aria-labelledby="headingThree"
          data-parent="#accordionExample"
        >
          <div className="card-body">
            <p>
              Online Payment Statistics
              <Tooltip
                placement="bottom"
                title={OnlinePaymentStatistics}
                trigger={["click"]}
                color={["rgb(233 231 231)"]}
              >
                <i className="fa-sharp fa-solid fa-circle-question"></i>
              </Tooltip>
            </p>
            <Row>
              <Col span={12}>
                <div className="collected">
                  <span className="widget-info-box__datum">0%</span>
                  <h2 className="widget-info-box__description">
                    Payments Collected Online
                  </h2>
                  <a href="/">View history</a>
                </div>
              </Col>
              <Col span={11} offset={1}>
                <div className="collected">
                  <span className="widget-info-box__datum ">0%</span>
                  <h2 className="widget-info-box__description">
                    Units Paid Online
                  </h2>
                  <a href="/">View history</a>
                </div>
              </Col>
            </Row>

            <h3 className="dashboard-widget__subtitle">
              Want to increase Online Payments?{" "}
              <a href="/">
                {" "}
                See who's not paying online
              </a>
            </h3>
            <p>Online Portal Adoption</p>
            <ul className="adptn">
              <li>
                <span>0%</span>
                <h2>
                  Activated{" "}
                  <Tooltip
                    placement="top"
                    title={ActivatedToolTip}
                    trigger={["click"]}
                    color={["#fff"]}
                  >
                    <i className="fa-sharp fa-solid fa-circle-question"></i>
                  </Tooltip>
                </h2>
                <a href="/">View Tenants</a>
              </li>
              <li>
                <span>0%</span>
                <h2>
                  NON-ACTIVATED{" "}
                  <Tooltip
                    placement="top"
                    title={NonActivatedToolTip}
                    trigger={["click"]}
                    color={["#fff"]}
                  >
                    <i className="fa-sharp fa-solid fa-circle-question"></i>
                  </Tooltip>
                </h2>
                <a href="/">Send Activation Emails</a>
              </li>
              <li>
                <span>0%</span>
                <h2>
                  no email{" "}
                  <Tooltip
                    placement="top"
                    title={NoEmailToolTip}
                    trigger={["click"]}
                    color={["#fff"]}
                  >
                    <i className="fa-sharp fa-solid fa-circle-question"></i>
                  </Tooltip>
                </h2>
                <a href="/">View Tenants</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlinePayments;
